var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFairUsage({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 180,
    viewBox: "0 0 180 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M136.713 128.293C120.572 141.622 103.347 153.509 85.2251 163.825C80.3425 167.229 74.8472 169.604 69.0593 170.81C62.4407 171.382 55.8089 169.863 50.0568 166.457C50.0568 166.457 49.8263 166.457 49.7604 166.255C48.2123 165.478 46.6972 164.601 45.182 163.69C28.7127 153.567 14.1844 138.72 8.01865 120.026C6.90896 116.591 6.07057 113.071 5.51158 109.498C4.01923 99.1741 4.65425 88.645 7.37573 78.5894C11.1966 65.0166 17.7917 52.4331 26.7233 41.6743C37.1702 28.0654 51.2996 17.9135 67.3469 12.4863C73.6141 10.522 80.1216 9.47685 86.6756 9.38195C106.434 9.11201 126.425 16.468 143.981 26.2536C147.377 28.0974 150.676 30.1248 153.863 32.3274C159.715 36.1065 164.849 40.9427 169.016 46.6008C188.786 75.4513 157.221 110.342 136.713 128.293Z",
    fill: "#F4F4F5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7626 41.6853L149.315 40.084C149.315 40.084 149.547 81.7791 149.315 97.988C149.083 114.19 150.939 148.183 150.939 148.183C150.939 148.183 105.046 145.188 88.9679 145.188C72.8894 145.188 32.7949 144.831 32.7949 144.831C32.7949 144.831 37.4586 138.076 36.9951 103.294C36.5308 68.5035 36.7626 41.6853 36.7626 41.6853Z",
    fill: "#F4F4F5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9589 60.6352L35.9609 59.8985L36.0119 41.6832L36.014 40.9459L36.7513 40.9354L149.303 39.3341L150.061 39.3233L150.064 40.081L150.142 59.8976L150.145 60.6371L149.406 60.6505L149.392 59.9006C149.406 60.6505 149.406 60.6505 149.405 60.6505L149.404 60.6505L149.4 60.6506L149.383 60.6509L149.315 60.6521L149.048 60.6569L148.015 60.6752C147.116 60.6911 145.807 60.7138 144.173 60.7415C140.903 60.7969 136.328 60.872 131.105 60.951C120.659 61.109 107.618 61.2825 97.2431 61.3444M35.9589 60.6352L97.2386 60.5944M35.9589 60.6352L36.6954 60.6504M35.9589 60.6352L36.6954 60.6504M97.2431 61.3444L97.2386 60.5944M97.2431 61.3444C97.2431 61.3444 97.2432 61.3444 97.2433 61.3444L97.2386 60.5944M97.2431 61.3444C86.8627 61.4097 71.7238 61.2361 59.1848 61.0463C52.9142 60.9515 47.292 60.8525 43.2375 60.7772C41.2102 60.7396 39.5748 60.7079 38.4461 60.6856C37.8818 60.6745 37.4442 60.6657 37.1476 60.6597L36.8103 60.6528L36.7244 60.651L36.7027 60.6506L36.6972 60.6505L36.6959 60.6505C36.6956 60.6504 36.6954 60.6504 36.7109 59.9006M97.2386 60.5944C76.4957 60.7249 36.7109 59.9006 36.7109 59.9006M36.7109 59.9006L36.6954 60.6504M36.7109 59.9006L36.6954 60.6504",
    fill: "white",
    stroke: "#70758F",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M149.314 97.9888C149.082 114.191 150.938 148.184 150.938 148.184C150.938 148.184 105.045 145.188 88.9668 145.188",
    stroke: "#70758F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.32 66.573C29.5467 77.8347 29.7792 113.14 29.3149 123.035C28.8506 132.93 29.1349 135.506 29.3149 138.749C29.4949 142.02 29.0832 144.164 29.0832 144.164H33.1543",
    stroke: "#70758F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7857 70.1702H138.414V132.479L45.4199 130.933L46.7857 70.1702Z",
    fill: "white",
    stroke: "#70758F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4492 84.5994H138.413",
    stroke: "#70758F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3145 99.1904C46.3145 99.1904 97.9919 99.3646 137.818 99.9405",
    stroke: "#70758F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7559 115.548C45.7559 115.548 68.5081 117.3 84.4065 117.637C100.305 117.967 138.415 117.637 138.415 117.637",
    stroke: "#70758F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M60.9375 80.625C60.9375 80.625 60.9375 96.8103 60.9375 110.002C60.9375 123.189 60.9375 131.25 60.9375 131.25",
    stroke: "#70758F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M77.0625 70.1702V131.188",
    stroke: "#70758F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M93.5664 69.9395V131.442",
    stroke: "#70758F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M110.066 69.9395V131.442",
    stroke: "#70758F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M122.812 70.3125L123.75 119.063",
    stroke: "#70758F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M140.09 46.6806C140.476 46.5501 140.811 46.3986 141.172 46.2411C144.805 44.3855 147.304 37.1507 142.486 32.7937C137.668 28.4375 129.757 32.0722 130.221 40.3181",
    stroke: "#70758F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4184 58.8735C33.4184 58.8735 33.7004 68.8572 34.242 89.4711C34.7827 110.085 31.2051 141.541 31.2051 141.541",
    stroke: "#70758F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M117.176 46.6806C117.562 46.5501 117.897 46.3986 118.258 46.2411C121.891 44.3855 124.39 37.1507 119.572 32.7937C114.754 28.4375 106.843 32.0722 107.307 40.3181",
    stroke: "#70758F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M95.3728 46.6806C95.7591 46.5501 96.0943 46.3986 96.4551 46.2411C100.088 44.3855 102.587 37.1507 97.7692 32.7937C92.9509 28.4375 85.0403 32.0722 85.5039 40.3181",
    stroke: "#70758F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M73.324 46.8944C73.7102 46.7639 74.0455 46.6124 74.4063 46.4549C78.0394 44.5993 80.5385 37.3645 75.7203 33.0076C70.9021 28.6514 62.9915 32.2861 63.455 40.5319",
    stroke: "#70758F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4197 46.8944C51.8059 46.7639 52.1412 46.6124 52.502 46.4549C56.1351 44.5993 58.6342 37.3645 53.816 33.0076C48.9978 28.6514 41.0872 32.2861 41.5507 40.5319",
    stroke: "#70758F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M93.0726 96.9407H110.067L109.719 117.192H93.5763L92.0664 116.462L93.0726 96.9407Z",
    fill: "#F4526B"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M98.8112 104.441L97.3164 107.045",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M102.246 104.836C102.169 104.884 97.6855 113.213 97.6855 113.213",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M104.895 106.684L100.824 113.157",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M99.9213 117.051L93.078 117.04C92.8958 117.04 92.7165 117 92.5515 116.923C92.094 116.711 91.809 116.245 91.827 115.741L92.1495 106.79",
    stroke: "#70758F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFairUsage);
export default __webpack_public_path__ + "static/media/fair-usage.2c0bb5475b56e69b30f800b27a56f32c.svg";
export { ForwardRef as ReactComponent };